import { createCachedSelector } from 're-reselect';

import getDropdownSegments from '@/state/selectors/navigation/get-dropdown-segments';
import { IStore } from '@/state/slices/typings';

const getDropdownSegment = createCachedSelector(
	[getDropdownSegments, (_: IStore, index: number) => index],
	(dropdownSegments, index) =>
		dropdownSegments.length > index ? dropdownSegments[index] : undefined,
)((_: IStore, index: number) => String(index));

export default getDropdownSegment;
